export const buildProvenance = { "commitHash": "62376553adacbe7fd9a7d8f6ec66463e2ac92413", "branchName": "refs/heads/release/2023.3", "buildDate": "2023-11-20T03:44:49.924Z", "version": "2023.3.13190" };
